// extracted by mini-css-extract-plugin
export default {"button":"ButtonLinkHome_button__jZv++"};